/* @flow */
import * as React from 'react';

const CreditCardAmex = props => (
  <svg focusable="false" viewBox="0 0 32 21" fill="#1D91CE" fillRule="evenodd" {...props}>
    <path d="M26.58,21 H2.42 A2.4,2.4 0 0 1 0,18.62 V4.38 A2.4,2.4 0 0 1 2.42,2 h24.16 A2.4,2.4 0 0 1 29,4.38 v14.25 A2.4,2.4 0 0 1 26.58,21 Z" />
    <polyline
      fill="#FFFFFF"
      points="4.063 13.896 3.591 15 -0.64 15 2.699 8 10.674 8 11.479 9.546 12.231 8 15.064 8 16.492 8 22.983 8 23.902 8.961 24.889 8 29.882 8 26.337 11.492 29.729 15 24.897 15 23.816 13.969 22.744 15 16.492 15 15.064 15 5.496 15 4.977 13.896"
    />
    <path d="M4.98,13.97 h-0.92 h0.92 Z M15.2,9 h-2.1 l-1.58,3.35 L9.82,9 h-2.1 v4.85 L5.55,9 H3.58 l-2.32,5 h1.42 l0.47,-1.14 h2.7 L6.39,14 H9 V9.93 L10.85,14 h1.22 l1.84,-4 v4 h1.29 V9 Z m8.67,1.62 L22.37,9 h-6.02 v5 H22.17 l1.65,-1.64 L25.48,14 h1.55 l-2.37,-2.53 L27.1,9 h-1.62 l-1.61,1.62 Z M20.7,13 h-3.06 V11.9 h3.06 V10.9 h-3.06 V10 h3.06 v-0.85 l2.27,2.27 l-2.27,2.28 V13 Z M4.53,9.82 l0.88,2.03 H3.58 l0.95,-2.03 Z" />
  </svg>
);

export default CreditCardAmex;



// WEBPACK FOOTER //
// ./src/assets/images/icons/credit-card-amex.js